export default __webpack_public_path__ + "static/media/BlueEyeIcon.05433e68.svg";